import { useRef, useEffect, useState } from 'react';
import gsap from 'gsap';
import emailjs from '@emailjs/browser';
import { colors } from '../sharedStyles';

export default function Contact() {
    const contactFormRef = useRef(null);
    const [isSending, setIsSending] = useState(false);

    // Initialiser EmailJS
    useEffect(() => {
        emailjs.init(process.env.REACT_APP_EMAILJS_PUBLIC_KEY || 'YOUR_PUBLIC_KEY');
    }, []);

    const handleContactSubmit = async (e) => {
        e.preventDefault();
        const button = contactFormRef.current?.querySelector('button[type="submit"]');

        setIsSending(true);

        try {
            // Envoyer l'email via EmailJS
            await emailjs.sendForm(
                process.env.REACT_APP_EMAILJS_SERVICE_ID || 'YOUR_SERVICE_ID',
                process.env.REACT_APP_EMAILJS_TEMPLATE_ID || 'YOUR_TEMPLATE_ID',
                contactFormRef.current
            );

            // Animation du bouton
            if (button) {
                gsap.to(button, { duration: 0.3, opacity: 0.7 });
                setTimeout(() => {
                    gsap.to(button, { duration: 0.3, opacity: 1 });
                }, 300);
            }

            alert('Merci pour votre message ! Je vous recontacterai au plus tôt.');
            contactFormRef.current?.reset();
        } catch (error) {
            console.error('Erreur lors de l\'envoi:', error);
            alert('Erreur lors de l\'envoi du message. Veuillez réessayer.');
        } finally {
            setIsSending(false);
        }
    };

    return (
        <section id="contact" style={{ paddingTop: '4rem', paddingBottom: '4rem', padding: '4rem 1.5rem', backgroundColor: colors.white, borderTop: '1px solid rgba(20, 45, 85, 0.1)' }}>
            <div style={{ maxWidth: '42rem', margin: '0 auto' }}>
                <h2 className="fade-in-up" style={{ fontSize: 'clamp(2.25rem, 8vw, 3rem)', fontWeight: 900, marginBottom: '1.5rem', textAlign: 'center', color: colors.text }}>
                    Structurer aujourd'hui pour décider librement demain.
                </h2>

                <p className="fade-in-up" style={{ textAlign: 'center', fontSize: '1.25rem', marginBottom: '2rem', fontWeight: 300, color: colors.text }}>
                    👉 Planifier un premier échange téléphonique
                </p>

                <form ref={contactFormRef} onSubmit={handleContactSubmit} style={{ display: 'flex', flexDirection: 'column', gap: '1.5rem' }}>
                    {/* Nom */}
                    <div className="fade-in-up">
                        <input
                            type="text"
                            name="name"
                            className="form-input"
                            style={{ color: colors.text, borderBottomColor: colors.text, fontSize: '1.125rem' }}
                            placeholder="Votre nom complet"
                            required
                        />
                    </div>

                    {/* Email */}
                    <div className="fade-in-up">
                        <input
                            name="email"
                            type="email"
                            className="form-input"
                            style={{ color: colors.text, borderBottomColor: colors.text, fontSize: '1.125rem' }}
                            placeholder="Votre adresse email"
                            required
                        />
                    </div>

                    {/* Message */}
                    <div className="fade-in-up">
                        <textarea
                            name="message"
                            className="form-input"
                            style={{ color: colors.text, borderBottomColor: colors.text, fontSize: '1.125rem', resize: 'none' }}
                            placeholder="Votre message"
                            rows="4"
                            required
                        />
                    </div>

                    {/* Submit Button */}
                    <div className="fade-in-up" style={{ paddingTop: '1rem' }}>
                        <button type="submit" className="btn-primary" style={{ width: '100%', justifyContent: 'center', fontSize: '1rem', padding: '0.75rem 0', opacity: isSending ? 0.7 : 1 }} disabled={isSending}>
                            {isSending ? 'Envoi en cours...' : 'Envoyer mon message'}
                        </button>
                    </div>
                </form>

                <div className="fade-in-up" style={{ marginTop: '3rem', textAlign: 'center' }}>
                    <p style={{ fontWeight: 300, fontSize: '1.125rem', color: colors.text }}>
                        Basé en Auvergne — Intervention sur toute la France.
                    </p>
                </div>
            </div>
        </section>
    );
}
